import gql from 'graphql-tag'

export default gql`
{
  sells(sort: _ID_DESC) {
    _id
    total
    items {
      _id
      itemId
      productId
      product {
        name
        size
        color
        price
      }
    }
    sellBy {
      name
    }
    sellAt
  }
}
`



// WEBPACK FOOTER //
// ./src/graphql/queries/sells.js